{
  "titles": {
    "menu": "Klanten",
    "financeReceivers": "Klanten",
    "create": "Klant aanmaken",
    "update": "Klant wijzigen",
    "partners": "Partners",
    "accounts": "Gebruikers",
    "contactPerson": "Contactpersoon",
    "riskProfile": "Risicoprofiel",
    "facilities": "Faciliteit",
    "details": "Algemeen",
    "dashboard": "Dashboard",
    "revolvingCreditFacility": "Kredietoverzicht",
    "onboarding": "Onboarding",
    "collaterals": "Zekerheden",
    "agreements": "Overeenkomsten",
    "contracts": "Contracten",
    "refinancing": "Herfinanciering",
    "check": "Controle",
    "cashFlow": "Cashflow",
    "communication": "Communicatie",
    "messageBoxMessages": "Berichtenbox berichten",
    "companyInformation": "Bedrijfsinformatie",
    "allFinanceReceivers": "Alle klanten",
    "defaultingFinanceReceivers": "Klanten in gebreke",
    "delinquentFinanceReceivers": "Klanten in bijzonder beheer",
    "creditLimitRequest": "Wijziging faciliteit",
    "bankAccounts": "Bankrekening(en)",
    "repaymentFlow": "Terugbetalingen inzichten",
    "createFinanceReceiverRealEstate": "Vastgoed klant aanmaken"
  },
  "fields": {
    "labels": {
      "financeReceiver": "Klant",
      "companyName": "Bedrijfsnaam",
      "legalStructure": "Rechtsvorm",
      "registrationNumber": "KvK- of registratienummer",
      "registeredOffice": "Statutaire zetel",
      "activityCodes": "Bedrijfssector",
      "address": "Adres",
      "phone": "Telefoonnummer",
      "companyUrl": "Website",
      "organisationalChart": "Organogram",
      "companyStartDate": "Startdatum bedrijf",
      "companyStatus": "Bedrijfsstatus",
      "customerSince": "Klant sinds",
      "advisors": "Adviseurs",
      "contactPersonId": "Contactpersoon",
      "status": "Status",
      "iban": "IBAN",
      "reimbursementAmount": "Terug te betalen bedrag",
      "reimbursementDate": "Datum terugbetaling",
      "beneficiaryName": "Naam rekeninghouder",
      "contactPerson": "Contactpersoon",
      "description": "Omschrijving",
      "amountDefaulting": "Bedrag achterstand",
      "totalOverdueAmount": "Bedrag achterstand",
      "paymentRemindersSent": "Herinneringen verstuurd",
      "lastPaymentReminderSentAt": "Laatste herinnering",
      "noteActionLocation": "Waar in behandeling",
      "noteBody": "Laatste notitie",
      "noteActionOwnerName": "Eigenaar actie",
      "noteActionDeadline": "Volgende deadline",
      "unlimited": "Onbeperkt",
      "actions": "Acties",
      "newIban": "Nieuwe SEPA IBAN",
      "directDebitLimit": "Incassolimiet",
      "newDirectDebitLimit": "Nieuw incassolimiet",
      "isCurrentSepaIbanClosed": "Oude SEPA IBAN wordt/is opgeheven",
      "isNewSepaConnectedWithPsd": "Nieuwe SEPA IBAN is gekoppeld met PSD",
      "newSepaFile": "Upload nieuwe SEPA machtiging",
      "sepaFileChecked": "Machtiging is gecontroleerd op volledigheid en incassolimiet",
      "twikeyRequestMade": "Ik heb Twikey een verzoek gestuurd om de incasso's te verzetten.",
      "uploadComplete": "SEPA formulier is gecontroleerd en geüpload",
      "from": "Van",
      "to": "Tot",
      "sepaFile": "SEPA machtiging",
      "authorizationChecked": "Machtiging is gecontroleerd op volledigheid en incassolimiet",
      "advisorId": "Adviseur",
      "generalPhone": "Algemeen telefoonnummer",
      "companySearch": "Zoek bedrijf",
      "facilities": "Product"
    },
    "hints": {},
    "validationErrors": {
      "companySearch": {
        "required": "Een bedrijf selecteren verplicht",
        "unique": "Dit bedrijf is al een klant"
      }
    }
  },
  "headers": {
    "labels": {
      "facilities": "Product",
      "contactPersonName": "Contactpersoon",
      "partner": "Partner",
      "advisor": "Adviseur"
    }
  },
  "errors": {
    "maxAdvisors": "Je kunt maximaal 2 adviseurs kiezen"
  },
  "messages": {
    "createSuccess": "Klant aangemaakt",
    "updateSuccess": "Klant is opgeslagen",
    "collateralNeedsApproval": "{collateral} gecontroleerd?",
    "collateralApproved": "{collateral} is gecontroleerd door {user} op {date}",
    "noCollaterals": "Er zijn geen zekerheden ingevoerd.",
    "noRefinancing": "Er is geen herfinanciering ingevoerd.",
    "collateralCompletedAt": "{type} gecontroleerd door {user} op {date}",
    "refinancingChecked": "Herfinanciering is gecontroleerd door {user} op {date}",
    "finalCheckNeeded": "De herfinanciering moet nog gecontroleerd worden door iemand met de juiste rechten",
    "internalNoticeAdded": "Interne notitie toegevoegd voor klant {name}",
    "hasPausedLoanExtraCosts": "In-gebreke berekening gepauzeerd",
    "psdCompleted": "Alle bankrekeningen zijn gekoppeld en gecontroleerd door {user} op {at}",
    "noBankAccounts": "De klant moet nog bankrekeningen koppelen.",
    "allRequestsSend": "In afwachting van koppeling van bankrekening(en) door de klant.",
    "updateMandateTwikey": "Deze klant heeft mogelijk incasso’s die in de toekomst geïncasseerd gaan worden. Stuur een supporticket naar Twikey met het verzoek om alle incasso’s te verzetten van machtiging <strong>{oldMandate}</strong> naar de nieuwe machtiging <strong>{newMandate}</strong> onder naam van <strong>{name}</strong>.",
    "sepaNotConnectedInPSD": "De klant moet de nieuwe SEPA IBAN nog koppelen met de PSD, de taak kan hierdoor nog niet afgerond worden.",
    "noPSDPermission": "Je hebt geen toestemming om bankrekeningen te controleren.",
    "sepaCompleted": "De SEPA machtiging is gecontroleerd op volledigheid en incassolimiet en geüpload naar Twikey door {user} op {at}",
    "completedNoCollaterals": "De zekerheden zijn succesvol ingevoerd.",
    "disabledWhileOnboardingOrCreditLimitRequest": "Niet mogelijk tijdens onboarding of wijziging kredietlimiet",
    "sepaNotCompleted": "De SEPA machtiging moet eerst (digitaal) ondertekend worden.",
    "collateralsCompleted": "De zekerheden zijn afgerond."
  },
  "actions": {
    "export": "Exporteren",
    "create": "Klant aanmaken",
    "update": "Klant aanpassen",
    "createUser": "Gebruiker aanmaken",
    "searchFinanceReceiver": "Zoek een klant",
    "searchFinanceReceiverLoan": "Zoek een lening",
    "collaterals": "Zekerheden controleren",
    "scheduled": "Ingepland",
    "markAsDelinquent": "Zet in bijzonder beheer",
    "eventUpdates": "Creditsafe-updates bekijken",
    "allBankAccountsChecked": "Alle bankrekeningen zijn gekoppeld en gecontroleerd",
    "addMissingBankAccount": "Ontbrekende bankrekening toevoegen",
    "sendRequestToConnect": "Stuur verzoek om te koppelen",
    "uploadCollaterals": "Zekerheden uploaden",
    "goToTwikey": "Naar Twikey",
    "completeRequest": "Aanvraag afronden",
    "uploadSepa": "SEPA machtiging uploaden"
  },
  "enums": {
    "FinanceReceiverFacility": {
      "RevolvingCredit": "Rekening Courant",
      "RealEstate": "Vastgoed"
    }
  },
  "facility": {
    "titles": {
      "loans": "Leningen",
      "create": "Faciliteit aanmaken",
      "update": "Faciliteit wijzigen",
      "facilities": "Rekening courant faciliteit",
      "changeWithNewQuote": "Kredietfaciliteit wijziging starten",
      "sendNewOffer": "Invullen en versturen nieuwe offerte",
      "collaterals": "Zekerheden",
      "supplementCollaterals": "Zekerheden aanvullen of wijzigen",
      "changeFacility": "Wijzig faciliteit",
      "signingAuthorities": "Ondertekenaar(s)",
      "block": "Faciliteit handmatig blokkeren",
      "unblock": "Handmatige blokkade opheffen"
    },
    "messages": {
      "block": "Je gaat de faciliteit blokkeren. <br /> De klant heeft geen toegang tot het krediet, totdat deze wordt gedeblokkeerd.",
      "unblock": "Mits er geen andere blokkades actief zijn, heeft de klant weer toegang tot het krediet en kan direct weer leningen indienen.",
      "facilityIsBlocked": "Het krediet is geblokkeerd en tijdelijk niet toegankelijk voor de klant.",
      "blockedReasons": "Dit heeft de volgende reden(en):",
      "facilityIsNotOnboarded": "Het krediet is nog niet toegankelijk voor de klant, omdat de onboarding nog niet is afgerond.",
      "requestedLoansWarning": "Deze klant heeft een of meerdere leningen aangevraagd, je kunt de faciliteit nu niet aanpassen.",
      "updateSuccess": "Faciliteit is opgeslagen",
      "createSuccess": "Faciliteit en zekerheden zijn aangemaakt",
      "offerSend": "De offerte is naar de klant verstuurd.",
      "noCollaterals": "Deze klant heeft nog geen zekerheden.",
      "defaultedForAmount": "De klant is bij deze faciliteit in gebreke voor {amount}",
      "paymentReferencePrepared": "Betalingsherinnering verzonden.",
      "paymentReminderAlreadySentToday": "Er is vandaag al een betalingsherinnering verstuurd."
    },
    "fields": {
      "validationErrors": {
        "collaterals": {
          "type": {
            "enum": "Soort zekerheid is verplicht"
          }
        }
      },
      "labels": {
        "creditLimit": "Kredietlimiet",
        "creditLimitChangeReason": "Toelichting",
        "withdrawnAmount": "Opgenomen krediet",
        "interestRate": "Tarief per 30 dagen",
        "previousLoanStartDate": "Datum laatste lening",
        "totalScheduledDirectDebitAmount": "Totaal toekomstige incasso's",
        "reason": "Toelichting",
        "totalFailedDirectDebitsAmount": "Totaal gemiste incasso's",
        "totalPenaltyAmount": "Extra rentekosten",
        "totalAdministrationCosts": "Totaal administratiekosten",
        "totalOverdueAmount": "Totaal achterstallige betalingen",
        "collateralsGroup": "Zekerheden",
        "newCreditLimit": "Nieuw kredietlimiet",
        "renewalOption": "Actie zekerheid",
        "newCollaterals": "Zekerheden toevoegen",
        "collaterals": {
          "type": "Soort zekerheid",
          "description": "Offerte tekst"
        }
      }
    },
    "errors": {
      "messages": {
        "404": "Deze klant heeft geen faciliteiten"
      }
    },
    "actions": {
      "update": "Faciliteit aanpassen",
      "change": "Faciliteit wijzigen",
      "changeWithNewQuote": "Faciliteit wijzigen met nieuwe offerte",
      "block": "Faciliteit handmatig blokkeren",
      "unblock": "Handmatige blokkade opheffen",
      "create": "Faciliteit aanmaken",
      "sendOffer": "Offerte versturen",
      "preparePaymentReference": "Betalingsherinnering verzenden"
    }
  },
  "create": {
    "titles": {
      "create": "Klant aanmaken"
    },
    "fields": {
      "labels": {
        "facilityType": "Soort faciliteit"
      }
    },
    "steps": {
      "companyDetails": "Bedrijfsgegevens",
      "facility": "Faciliteit",
      "user": "Gebruiker aanmaken"
    }
  },
  "realEstateFacility": {
    "titles": {
      "quote": "Samenvatting",
      "facility": "Tijdelijke Overbrugging Vastgoedfinanciering",
      "additionalInformation": "Aanvullende informatie",
      "update": "Faciliteit aanpassen"
    },
    "fields": {
      "labels": {
        "principalAmount": "Hoofdsom",
        "durationInMonths": "Looptijd",
        "yearlyInterestRate": "Jaarrente",
        "arrangementFeeRate": "Afsluitprovisie",
        "exitFeeRate": "Exitfee (optioneel)",
        "repaymentDescription": "Eindaflossing",
        "monthlyInterestAmount": "Maandrente",
        "arrangementFeeAmount": "Afsluitprovisie",
        "exitFeeAmount": "Exitfee",
        "exitFee": "Exitfee"
      },
      "hints": {
        "repaymentDescription": "Beschrijf hier welke afspraken er zijn gemaakt om na de looptijd geherfinancierd te worden"
      }
    },
    "messages": {
      "createSuccess": "Vastgoedfinanciering is aangemaakt",
      "updateSuccess": "Vastgoedfinanciering is opgeslagen",
      "perMonth": "{amount} / maand",
      "noRealEstateFacility": "Deze klant heeft geen vastgoedfinanciering"
    },
    "actions": {
      "create": "Faciliteit aanmaken",
      "update": "Faciliteit aanpassen"
    }
  },
  "directDebits": {
    "titles": {
      "directDebits": "Incasso's",
      "manualRepayments": "Aflossingen log",
      "DirectDebit": "Incasso",
      "Transfer": "Overboeking"
    },
    "headers": {
      "labels": {
        "amount": "Bedrag",
        "description": "Omschrijving",
        "collectionDate": "Incassodatum",
        "bookDate": "Datum boeking",
        "status": "Status",
        "referenceNumber": "Referentienummer"
      }
    }
  },
  "collaterals": {
    "titles": {
      "refinancing": "Herfinanciering",
      "currentDebt": "Actieve stand vorige krediet- of hypotheekleverancier",
      "redeemConfirmation": "Bevestiging aflossing kredietleverancier",
      "newAdditionalDocument": "Nieuw aanvullend document",
      "newHistoricalVersion": "Nieuwe historische versie"
    },
    "addFile": "Voeg het document toe: {description}",
    "addCollateral": "Zekerheden toevoegen",
    "appendCollateral": "Nieuwe zekerheid toevoegen",
    "noFileUploaded": "Geen bestand toegevoegd",
    "additionalDocuments": "Aanvullende documenten ({number})",
    "historicalVersions": "Gearchiveerde versies ({number})",
    "historical": "GEARCHIVEERD",
    "reason": "Reden",
    "messages": {
      "creditProviderPaid": "Kredietleverancier is per {date} afbetaald en lening is aangemaakt.",
      "refinancingChecked": "Herfinanciering is gecontroleerd door {user} op {date}",
      "appendSuccess": "Zekerheid is toegevoegd",
      "collateralNeedsApproval": "{collateral} gecontroleerd?",
      "collateralApproved": "{collateral} is gecontroleerd door {user} op {date}"
    },
    "fields": {
      "labels": {
        "type": "Soort zekerheid",
        "description": "Omschrijving",
        "file": "Document",
        "internalNote": "Notitie (optioneel)",
        "amount": "Hoogte van zekerheid",
        "currentDebtAmount": "Hoogte stand vorige krediet- of hypotheekleverancier",
        "isRedeemedToday": "Krediet of hypotheek wordt per vandaag volledig afgelost",
        "refinancingChecked": "Herfinanciering gecontroleerd",
        "additionalDocumentType": "Soort document",
        "historicalVersionDate": "Datum document",
        "historicalVersionDescription": "Beschrijving",
        "historicalVersionAmount": "Bedrag",
        "historicalVersionReason": "Reden",
        "historicalVersionInternalNote": "Notitie (optioneel)",
        "isExpired": "Zekerheid is niet meer actueel",
        "expirationReason": "Reden",
        "date": "Datum"
      }
    },
    "errors": {
      "validation": {
        "maxDateWhen": "{0} moet uiterlijk {1} zijn"
      }
    },
    "actions": {
      "appendCollateral": "Zekerheid toevoegen",
      "openNewAdditionalDocumentForm": "Aanvullend document toevoegen",
      "addAdditionalDocument": "Toevoegen",
      "openNewHistoricalVersionForm": "Gearchiveerde versie toevoegen",
      "addHistoricalVersion": "Toevoegen"
    }
  },
  "contracts": {
    "titles": {
      "addContract": "Contract toevoegen"
    },
    "fields": {
      "labels": {
        "type": "Soort contract",
        "facility": "Faciliteit",
        "signedAt": "Datum document",
        "file": "Document"
      }
    },
    "actions": {
      "cancel": "Annuleren",
      "add": "Toevoegen",
      "addContract": "Contract toevoegen"
    },
    "facilities": {
      "revolvingCreditFacility": "Rekening-courant faciliteit",
      "realEstateLoan": "Vastgoed (aangemaakt op {date})"
    },
    "messages": {
      "addSuccess": "Contract is toegevoegd"
    },
    "errors": {
      "messages": {
        "500": "Er is iets mis gegaan bij het toevoegen van het contract"
      }
    }
  },
  "cashFlow": {
    "fields": {
      "labels": {
        "startDate": "Startdatum",
        "periodType": "Groepeer periode"
      },
      "periods": {
        "global": "Globaal",
        "daily": "Dagelijks",
        "weekly": "Wekelijks",
        "monthly": "Maandelijks",
        "quarterly": "Per kwartaal",
        "yearly": "Jaarlijks"
      }
    }
  },
  "bankAccounts": {
    "titles": {
      "bankAccounts": "Bankverbindingen",
      "sepaAccount": "SEPA rekening",
      "otherAccounts": "Overige rekeningen"
    },
    "messages": {
      "noSepaAccounts": "De klant heeft geen Sepa bankrekeningen gekoppeld",
      "noOtherAccounts": "De klant heeft geen overige bankrekeningen gekoppeld",
      "confirmDelete": "Hiermee wordt de bankrekening van deze klant verwijderd.",
      "confirmDisconnect": "Hiermee wordt de PSD2-koppeling verbroken.",
      "confirmConnect": "Hiermee wordt de PSD2-koppeling hersteld.",
      "allRequestsSent": "Alle verzoeken om te koppelen zijn verstuurd"
    },
    "statuses": {
      "expected": "Rekening moet nog worden gekoppeld",
      "expired": "De verbinding is verlopen",
      "reauthorizationUpcoming": "Rekening moet binnenkort opnieuw worden geautoriseerd",
      "connected": "Rekening is correct verbonden",
      "disconnected": "Autorisatie is verlopen"
    },
    "fields": {
      "labels": {
        "bankAccounts": "Bankrekeningen",
        "holderName": "t.n.v. {name}",
        "connectedAt": "Verbinding sinds: {date}",
        "reauthorizationExpectedAt": "Verbinding verloopt op: {date}",
        "iban": "IBAN"
      }
    },
    "actions": {
      "addMissingBankAccount": "Ontbrekende bankrekening toevoegen",
      "disconnectBankAccount": "Verbreek PSD verbinding",
      "connectBankAccount": "Activeer PSD verbinding",
      "sendRequestToConnect": "Verzoek om te koppelen versturen",
      "undoRequestToConnect": "Verzoek terugdraaien"
    }
  },
  "internalNotes": {
    "titles": {
      "table": "Interne notities",
      "sidebarTitle": "Notitie van {date}",
      "addInternalNote": "Interne notitie aanmaken",
      "connectedAction": "Gekoppelde actie"
    },
    "fields": {
      "labels": {
        "type": "Type",
        "contactAt": "Datum & Tijd",
        "body": "Notitie",
        "createdBy": "Notitie door",
        "actionDescription": "Nieuwe actie",
        "actionLocation": "Locatie actie",
        "actionDeadline": "Nieuwe deadline",
        "actionOwner": "Eigenaar actie"
      }
    },
    "messages": {
      "internalNotesSubtitle": "Deze informatie is vertrouwelijk en dient nooit naar de klant en/of partner gecommuniceerd te worden.",
      "confirmDeleteNote": "Weet je zeker dat de je deze notitie wil verwijderen? Dit kan niet ongedaan gemaakt worden."
    },
    "actions": {
      "addInternalNote": "Notitie toevoegen",
      "addInternalNoteAndAction": "Notitie & actie toevoegen",
      "deleteNoteAndAction": "Verwijder notitie & actie",
      "deleteNote": "Verwijder notitie",
      "createAction": "Actie en deadline toevoegen"
    }
  },
  "markDelinquent": {
    "titles": {
      "dialog": "Draag {name} over aan Bijzonder beheer"
    },
    "messages": {
      "dialogIntroText": "Met deze actie zetten we de klant over naar Bijzonder beheer en voorzien we geen oplossing meer binnen een minnelijke fase.",
      "dialogConsequencesTitle": "Overdragen aan bijzonder beheer betekent:",
      "dialogConsequence1": "Alle lopende leningen, die nog niet in gebreke zijn, worden niet meer automatisch geïncasseerd.",
      "dialogConsequence2": "Alle toekomstige incasso's worden geannuleerd.",
      "dialogConsequence3": "Er worden geen automatische herinneringen meer verzonden.",
      "dialogConsequence4": "Alle betalingen moeten handmatig worden bijgewerkt."
    },
    "notice": {
      "info": {
        "title": "Leningen worden geïncasseerd",
        "text": "Voor de volgende leningen kunnen de geplande incasso's niet meer geannuleerd worden en zullen aan de bank worden aangeboden:"
      },
      "warning": {
        "title": "Ophalen leningen mislukt",
        "text": "Er zijn mogelijk leningen die niet geannuleerd kunnen worden, maar op het moment kunnen deze niet opgehaald worden vanwege een fout in het systeem."
      }
    },
    "fields": {
      "labels": {
        "type": "Type",
        "contactAt": "Datum en tijd",
        "body": "Interne notitie",
        "confirmation": "Ik weet zeker dat {name} naar Bijzonder beheer gezet moet worden."
      }
    }
  },
  "eventUpdates": {
    "titles": {
      "dialogTitle": "Bedrijfsupdates via CreditSafe"
    },
    "messages": {
      "dialogText": "De volgende wijzigingen zijn bekend via CreditSafe.",
      "applySuccess": "De wijziging is aangevraagd en wordt zo snel mogelijk doorgevoerd."
    },
    "headers": {
      "name": "Regel naam",
      "previousValue": "Vorige waarde",
      "newValue": "Nieuwe waarde",
      "notificationDate": "Datum notificatie"
    },
    "actions": {
      "update": "Update klantdossier"
    }
  },
  "missingAgreementFields": {
    "titles": {
      "missingAgreementFields": "Gegevens ontbreken",
      "companyInformation": "Bedrijfsgegevens",
      "account": "Tekenbevoegde",
      "missingAccount": "Tekenbevoegde ontbreekt"
    },
    "messages": {
      "missingAgreementFields": "De offerte en de raamovereenkomst kunnen nog niet worden opgemaakt. Vul eerst de onderstaande gegevens aan.",
      "companyInformation": "De rechtsvorm of het adres uit Creditsafe is onvolledig. Deze gegevens kun je niet zelf aanpassen. Neem contact op met een beheerder.",
      "account": "De naam of het e-mailadres van deze tekenbevoegde is onvolledig.",
      "missingAccount": "Er is nog geen tekenbevoegde toegevoegd."
    },
    "actions": {
      "updateAccount": "Aanpassen",
      "createAccount": "Toevoegen",
      "close": "Sluiten"
    }
  }
}
